export class UserAppManagerBase {

    app_id!: number
    app_code!: string
    profile_id!: number
    profile_code!: string
    type!: string

    static fromUserAppManager(ap: UserAppManager): UserAppManagerBase {
        let current = new UserAppManagerBase()
        Object.assign(current, ap)
        return current;
    }

}

export interface UserAppManager extends UserAppManagerBase {

}
